import React, { Component } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Card, Pagination, Container, Row, Col } from 'react-bootstrap';

// Importación masiva de imágenes
import img42 from '../EquipoMedico/img42.jpg';
import img43 from '../EquipoMedico/img43.jpg';
import img44 from '../EquipoMedico/img44.jpg';
import img45 from '../EquipoMedico/img45.jpg';
import img46 from '../EquipoMedico/img46.jpg';
import img47 from '../EquipoMedico/img47.jpg';
import img48 from '../EquipoMedico/img48.jpg';
import img49 from '../EquipoMedico/img49.jpg';
import img50 from '../EquipoMedico/img50.jpg';
import img51 from '../EquipoMedico/img51.jpg';
import img52 from '../EquipoMedico/img52.jpg';
import img53 from '../EquipoMedico/img53.jpg';
import img54 from '../EquipoMedico/img54.jpg';
import img55 from '../EquipoMedico/img55.jpg';
import img56 from '../EquipoMedico/img56.jpg';
import img57 from '../EquipoMedico/img57.jpg';
import img58 from '../EquipoMedico/img58.jpg';
import img59 from '../EquipoMedico/img59.jpg';

export class MedicalInput3 extends Component {
    render() {
        // Estructura de datos para evitar repetir código de Cards
        const products = [
            { id: 42, title: "Wooden swabs", text: "Box of 100 Units", img: img42 },
            { id: 43, title: "Scalpel Sheets", text: "", img: img43 },
            { id: 44, title: "I.V Catheter", text: "", img: img44 },
            { id: 45, title: "I.V Catheter", text: "", img: img45 },
            { id: 46, title: "I.V Butterfly Catheter", text: "", img: img46 },
            { id: 47, title: "I.V Catheter", text: "", img: img47 },
            { id: 48, title: "Disposable insulin syringe", text: "Individual packaging", img: img48 },
            { id: 49, title: "Disposable syringe 3cc, 5cc, 10cc", text: "Individual packaging", img: img49 },
            { id: 50, title: "Nelaton Catheter", text: "", img: img50 },
            { id: 51, title: "Eye patches", text: "", img: img51 },
            { id: 52, title: "Foley Catheter", text: "", img: img52 },
            { id: 53, title: "Rectal Catheter", text: "", img: img53 },
            { id: 54, title: "Chemical sutures", text: "Nylon, silk, catgut chromic, catgut simple, polypropylene, polyester braided, polyglycolic acid.", img: img54 },
            { id: 55, title: "Thermometers", text: "", img: img55 },
            { id: 56, title: "Endotracheal tubes", text: "", img: img56 },
            { id: 57, title: "Endotracheal tubes", text: "", img: img57 },
            { id: 58, title: "Endotracheal tubes", text: "", img: img58 },
            { id: 59, title: "Endotracheal tubes", text: "", img: img59 },
        ];

        return (
            <div>
                <Header />
                <br />
                    <h1 className='text-center'>Medical Supplies</h1>
                <Container><br />
                    {/* Navegación Superior */}
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/MedicalInput">{1}</Pagination.Item>
                        <Pagination.Item href="/en/MedicalInput2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>
                    <br />

                    {/* Grilla de Productos */}
                    <Row xs={1} md={2} className="g-4 mb-4">
                        {products.map((product) => (
                            <Col key={product.id}>
                                <Card className="h-100 shadow-sm">
                                    <Card.Header>
                                        <h5 className="mb-0">Disposable products</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row className="align-items-center">
                                            <Col xs={7}>
                                                <Card.Title className="color-texto">{product.title}</Card.Title>
                                                {product.text && <Card.Text className="text-muted">{product.text}</Card.Text>}
                                            </Col>
                                            <Col xs={5}>
                                                <Card.Img 
                                                    variant="top" 
                                                    src={product.img} 
                                                    alt={product.title}
                                                    style={{ objectFit: 'contain', maxHeight: '120px' }}
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    {/* Navegación Inferior */}
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/MedicalInput">{1}</Pagination.Item>
                        <Pagination.Item href="/en/MedicalInput2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        );
    }
}